/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import LoaderButton from 'shared/ui/components/form-components/LoaderButton.vue';

/**
 * Component for showing the delete action confirmation.
 *
 * @vue-prop {Function} delete the delete callback to call when confirmed
 * @vue-prop {String} type of document
 *
 * @category content-hub.components.modals
 * @exports MediaDeleteAction
 */
const __vue_script__ = {
    name: 'MediaDeleteAction',

    components: { LoaderButton },

    props: {
        delete: {
            type: Function,
            required: true
        },
        type: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            typeLabel: this.$i18n.tc(`contents.type.${this.type}`, 1),
            loading: false,
        };
    },

    methods: {
        /**
         * Delete the given media/content and show a notification according to how it went.
         */
        async deleteMedia() {
            try {
                this.loading = true;
                await this.delete();
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('contents.messages.delete_success').toString(),
                    type: 'success',
                    duration: 5000
                });
                this.loading = false;
                this.$emit('close');
            } catch (error) {
                this.loading = false;
                console.error('[MediaDeleteAction] Could not delete selected item', error);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('contents.messages.delete_failed').toString(),
                    type: 'error',
                    duration: 5000
                });
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents-bulk-action modal-wrapper" }, [
    _c("div", { staticClass: "modal-header" }, [
      _c("span", {
        staticClass: "close",
        on: {
          click: function () {
            return _vm.$emit("close")
          },
        },
      }),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("contents.delete.title", [_vm.typeLabel]))),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c("i18n", { attrs: { tag: "p", path: "contents.delete.body" } }, [
          _c("span", [_vm._v(_vm._s(_vm.typeLabel))]),
          _c("br"),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "button",
          {
            staticClass: "btn",
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("general.cancel")))]
        ),
        _c(
          "loader-button",
          {
            staticClass: "btn btn-danger",
            attrs: { status: _vm.loading },
            on: { click: _vm.deleteMedia },
          },
          [_vm._v(_vm._s(_vm.$t("general.delete")))]
        ),
      ],
      1
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/content-hub/src/components/modals/MediaDeleteAction.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__